<template>
  <el-menu-item :index="'' + index" v-if="!items.children || items.children.length === 0">
    <!-- 廖欢让去掉 -->
    <!-- <img v-if="items.iconUrl" class="data-icon" :src="items.iconUrl" alt="" /> -->
    <span :style="getTitleStyle">{{ options.topNavTextLimit1 ? items.label.substr(0, options.topNavTextLimitCount1) : items.label }}</span>
  </el-menu-item>
  <el-submenu
    :popper-append-to-body="false"
    v-else-if="items.children && items.children.length > 0"
    :index="'' + index"
    @click.native = "handleMenuClick(index,items)"
  >
    <template slot="title">
      <span v-if="options.iconPosition === 'right'" :style="getSubTextColor">{{ options.topNavTextLimit1 ? items.label.substr(0, options.topNavTextLimitCount1) : items.label }}</span>
      <cxIcon
        :class="options.iconPosition === 'right' ? 'right-icon icon' : 'left-icon icon'"
        v-if="options.iconType === 'icon'"
        :options="options"
        :iconStyle="getIconStyle"
      ></cxIcon>
      <img
        :class="options.iconPosition === 'right' ? 'right-icon icon' : 'left-icon icon'"
        v-else-if="options.iconType === 'img' && options.iconSrc"
        :src="options.iconSrc"
        :style="getIconImgStyle"
      />
      <span v-if="options.iconPosition === 'left'" :style="getSubTextColor">{{ options.topNavTextLimit1 ? items.label.substr(0, options.topNavTextLimitCount1) : items.label }}</span>
    </template>
    <cx-menu-tree
      v-for="(child_option, child_index) in items.children"
      :style="getPopperStyle"
      :key="child_index"
      :items="child_option"
      :popper-append-to-body="false"
      :index="index + '_' + (child_index + 1)"
      :options="options"
      @handleMenuClick="handleMenuClick"
    ></cx-menu-tree>
  </el-submenu>
</template>

<script>
export default {
  name: "cx-menu-tree",
  props: {
    items: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    getSubTextColor(){
      let colorName = 'liFontColorArr',oldColorName = 'liFontColor', colorIsThemeColor = 'liIsThemeColor'
      let hoverColorName = 'liHoverFontColorArr',hoverOldColorName = 'liHoverFontColor',hoverColorIsThemeColor = 'liHoverTextIsThemeColor'
      let activeColorName = 'liActiveFontColorArr', activeOldColorName = 'liActiveFontColor',activeColorIsThemeColor ='liActiveTextIsThemeColor'
      let hoverColor = {},activeColor={}
      // 激活颜色
      if(this.options[activeColorIsThemeColor]){
        activeColor = {
          "--liActiveColor": this.themeColor
        }
      } else if(!this.options[activeColorName]){
        activeColor = {
          // "--liActiveColor": this.options[activeOldColorName] && this.options[activeOldColorName].color?this.options[activeOldColorName].color:this.options[activeOldColorName]
          "--liActiveColor": this.$parseColor(this.options[activeOldColorName])
        }
      } else if(this.options[activeColorName].type === "color"){
        activeColor = {
          // "--liActiveColor": this.options[activeColorName].color ? this.options[activeColorName].color:this.options[activeColorName].data?.stops[0][0]
          "--liActiveColor": this.$parseColor(this.options[activeColorName])
        }
      }else if(this.options[activeColorName].type === 'linearGradient'){
        //老数据兼容 有些colorArr.data.stops不是数组
        let tmp=[]
        this.options[activeColorName].data.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        activeColor =  {
          "--liActiveColor": "transparent",
          // "--liActiveBackgroundImage": `-webkit-linear-gradient(${this.options[activeColorName].data.angle}deg, ${tmp.join(",")})`,
          "--liActiveBackgroundImage": this.$parseColor(this.options[activeColorName]),
          "-webkit-background-clip": "text"
        }
      }
      // 悬浮颜色
      if(this.options.hoverIsSameActive){
        hoverColor = {
          "--liHoverColor": activeColor['--liActiveColor'],
          "--liHoverBackgroundImage": activeColor['--liActiveBackgroundImage'],
          "-webkit-background-clip": "text"
        }
      }else{

        if(this.options[hoverColorIsThemeColor]){
          hoverColor = {
            "--liHoverColor": this.themeColor
          }
        } else if(!this.options[hoverColorName]){
          hoverColor = {
            // "--liHoverColor": this.options[hoverOldColorName].color?this.options[hoverOldColorName].color:this.options[hoverOldColorName]
            "--liHoverColor": this.$parseColor(this.options[hoverOldColorName]),
          }
        } else if(this.options[hoverColorName].type === "color"){
          hoverColor = {
            // "--liHoverColor": this.options[hoverColorName].color ? this.options[hoverColorName].color:this.options[hoverColorName].data?.stops[0][0]
            "--liHoverColor": this.$parseColor(this.options[hoverColorName]),
          }
        }else if(this.options[hoverColorName].type === 'linearGradient'){
          //老数据兼容 有些colorArr.data.stops不是数组
          let tmp=[]
          this.options[hoverColorName].data.stops.forEach(item => {
            tmp.push(item[0] + " " + item[1] * 100 + "%")
          })
          hoverColor =  {
            "--liHoverColor": "transparent",
            // "--liHoverBackgroundImage": `-webkit-linear-gradient(${this.options[colorName].data.angle}deg, ${tmp.join(",")})`,
            "--liHoverBackgroundImage": this.$parseColor(this.options[hoverColorName]),
            "-webkit-background-clip": "text"
          }
        }
      }
      // 常规颜色
      if(this.options[colorIsThemeColor]){
        return {
          ...activeColor,
          ...hoverColor,
          color: this.themeColor
        }
      }
      if(!this.options[colorName]){
        return {
          ...activeColor,
          ...hoverColor,
          // color: this.options[oldColorName]
          color: this.$parseColor(this.options[oldColorName]),
        }
      }
      if(this.options[colorName].type === "color"){
        return {
          ...activeColor,
          ...hoverColor,
          // color: this.options[colorName].color ? this.options[colorName].color:this.options[colorName].data?.stops[0][0]
          color: this.$parseColor(this.options[colorName])
        }
      }else if(this.options[colorName].type === 'linearGradient'){
        //老数据兼容 有些colorArr.data.stops不是数组
        let tmp=[]
        this.options[colorName].data.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        return  {
          ...activeColor,
          ...hoverColor,
          color: "transparent",
          // backgroundImage: `-webkit-linear-gradient(${this.options[colorName].data.angle}deg, ${tmp.join(",")})`,
          backgroundImage: this.$parseColor(this.options[colorName]),
          "-webkit-background-clip": "text"
        }
      }
    },
    getFixToRightStyle() {
      if (this.options.iconPosition === "right") {
        return {
          position: "absolute",
          right: "10px",
          top: "50%"
          // marginTop: -this.options.iconWidth / 2 + "px"
        }
      } else {
        return {}
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getIconStyle() {
      return {
        ...this.getFixToRightStyle,
        // "--iconColor": this.options.iconColorIsThemeColor ? this.themeColor : this.options.iconColor,
        "--iconColor": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    getIconImgStyle() {
      return {
        ...this.getFixToRightStyle,
        width: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getTitleStyle() {
      if (this.options.iconPosition === "left") {
        return {
          ...this.getSubTextColor,
          marginLeft: this.options.iconMargin + "px"
        }
      }else{
        return {
          ...this.getSubTextColor
        }
      }
    },
    topNavBgStyle1() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.topNavBackground1
      if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.topNavBgColorIsThemeColor ? true : false,
            color: this.options.topNavBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //     ? this.themeColor
            //     : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            break
          default:
        }
      })
      return containerBg
    },
    liActiveBg(){
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liActiveBgColor
      if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("liActiveBgIsThemeColor")
                ? this.options.liActiveBgIsThemeColor
                : false,
            color: this.options.liActiveBgColor.color
                ? this.options.liActiveBgColor.color
                : this.options.liActiveBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //     ? this.themeColor
            //     : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            break
          default:
        }
      })
      return containerBg
    },
    liActiveBgStyle() {
      return {
        "--activeBackgroundImage1": this.liActiveBg.backgroundImage,
        "--activeBackgroundSize1": this.liActiveBg.backgroundSize,
        "--activeBackgroundPosition1": this.liActiveBg.backgroundPosition,
        "--activeBackgroundRepeat1": this.liActiveBg.backgroundRepeat,
        "--activeBackgroundColor1": this.liActiveBg.backgroundColor
      }
    },
    liHoverBgStyle() {
      if (this.options.liHoverIsSameActive) {
        return {
          "--hoverBackgroundImage1": this.liActiveBg.backgroundImage,
          "--hoverBackgroundSize1": this.liActiveBg.backgroundSize,
          "--hoverBackgroundPosition1": this.liActiveBg.backgroundPosition,
          "--hoverBackgroundRepeat1": this.liActiveBg.backgroundRepeat,
          "--hoverBackgroundColor1": this.liActiveBg.backgroundColor
        }
      }
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liHoverBgColor
      if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("liHoverBgIsThemeColor")
                ? this.options.liHoverBgIsThemeColor
                : false,
            color: this.options.liHoverBgColor.color ? this.options.liHoverBgColor.color : this.options.liHoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //     ? this.themeColor
            //     : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            break
          default:
        }
      })
      return {
        "--hoverBackgroundImage1": containerBg.backgroundImage,
        "--hoverBackgroundSize1": containerBg.backgroundSize,
        "--hoverBackgroundPosition1": containerBg.backgroundPosition,
        "--hoverBackgroundRepeat1": containerBg.backgroundRepeat,
        "--hoverBackgroundColor1": containerBg.backgroundColor
      }
    },
    getPopperStyle() {
      // hover
      let borderW = "",
          hoverBorderW = ""
      if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(borderW += `${item}px `)])
      } else {
        borderW += ` ${this.options.liBorderWidth}px`
      }
      if (Array.isArray(this.options.liHoverBorderWidth)) {
        this.options.liHoverBorderWidth.forEach(item => [(hoverBorderW += `${item}px `)])
      } else {
        hoverBorderW += ` ${this.options.liHoverBorderWidth}px`
      }
      borderW = borderW.trim()
      hoverBorderW = !this.options.liHoverIsSameActive ? hoverBorderW.trim() : borderW
      let borderBottomWidth = this.options.clearLiLastBorder
          ? "0px"
          : borderW.split(" ").length > 1
              ? borderW.split(" ")[2]
              : borderW
      let liHoverBorderBottomWidth = this.options.liHoverIsSameActive
          ? borderBottomWidth
          : this.options.clearLiHoverLastBorder
              ? "0px"
              : hoverBorderW.split(" ").length > 1
                  ? hoverBorderW.split(" ")[2]
                  : hoverBorderW
      // active
      let activeBorderW = ""
      if (Array.isArray(this.options.liActiveBorderWidth)) {
        this.options.liActiveBorderWidth.forEach(item => [(activeBorderW += `${item}px `)])
      } else {
        activeBorderW += ` ${this.options.liActiveBorderWidth}px`
      }
      activeBorderW = activeBorderW.trim()
      let activeBorderBottomWidth = this.options.clearLiActiveLastBorder
          ? "0px"
          : activeBorderW.split(" ").length > 1
              ? activeBorderW.split(" ")[2]
              : activeBorderW
      let bg = {
        "--backgroundImage1": this.topNavBgStyle1?.backgroundImage,
        "--backgroundSize1": this.topNavBgStyle1?.backgroundSize,
        "--backgroundPosition1": this.topNavBgStyle1?.backgroundPosition,
        "--backgroundRepeat1": this.topNavBgStyle1?.backgroundRepeat,
        "--backgroundColor1": this.topNavBgStyle1?.backgroundColor
      }
      // let liActiveFontColor = this.options.liActiveTextIsThemeColor
      //     ? this.themeColor
      //     : this.options.liActiveFontColor && this.options.liActiveFontColor.color
      //         ? this.options.liActiveFontColor.color
      //         : this.options.liActiveFontColor
      let liActiveFontColor = this.$parseColor(this.options.liActiveFontColor, {
        isThemeColor: this.options.liActiveTextIsThemeColor
      })
      // let liActiveBorderColor = this.options.liActiveBorderIsThemeColor
      //     ? this.themeColor
      //     : this.options.liActiveBorderColor && this.options.liActiveBorderColor.color
      //         ? this.options.liActiveBorderColor.color
      //         : this.options.liActiveBorderColor
      let liActiveBorderColor = this.$parseColor(this.options.liActiveBorderColor, {
        isThemeColor: this.options.liActiveBorderIsThemeColor
      })
      let actualLiActiveLineHeight = this.options.liActiveLineHeightType === '%' ? (this.options.liActiveLineHeight / 100 * this.options.liActiveFontSize) : this.options.liActiveLineHeight
      let liActiveLineHeight = this.options.liIsSameSize ? (actualLiActiveLineHeight + "px") : (this.options.liHeight + "px")
      let actualLiLineHeight = this.options.liLineHeightType === '%' ? (this.options.liLineHeight / 100 * this.options.liFontSize) : this.options.liLineHeight
      let actualLiHoverLineHeight = this.options.liHoverLineHeightType === '%' ? (this.options.liHoverLineHeight / 100 * this.options.liHoverFontSize) : this.options.liHoverLineHeight
      return {
        ...this.liActiveBgStyle,
        ...this.liHoverBgStyle,
        "--liLineHeight": actualLiLineHeight + "px",
        "--liHeight": this.options.liIsSameSize ? (actualLiLineHeight + "px") : (this.options.liHeight + "px"),
        "--liWidth": this.options.liIsSameSize ? "" : this.options.liWidth + "px",
        // "--iconColor": this.options.liIsThemeColor ? this.themeColor : this.options.liFontColor,
        "--iconColor": this.$parseColor(this.options.liFontColor, {
          isThemeColor: this.options.liIsThemeColor
        }),
        "--fontWeight": this.options.liFontWeight,
        "--fontSize": this.options.liFontSize + "px",
        "--fontFamily": this.options.liFontFamily,
        "--fontStyle": this.options.liFontStyle,
        "--textAlign": this.options.liTextAlign,
        "--writingMode": this.options.liWritingMode,
        "--letterSpacing": this.options.liLetterSpacing + "px",
        "--textDecoration": this.options.liTextDecoration,
        "--borderWidth": borderW,
        "--borderBottomWidth": borderBottomWidth,
        "--borderStyle": this.options.liBorderStyle,
        // "--borderColor1": this.options.liBorderIsThemeColor
        //     ? this.themeColor
        //     : this.options.liBorderColor && this.options.liBorderColor.color
        //         ? this.options.liBorderColor.color
        //         : this.options.liBorderColor,
        "--borderColor1": this.$parseColor(this.options.liBorderColor, {
          isThemeColor: this.options.liBorderIsThemeColor
        }),
        // "--liHoverColor": this.options.liHoverIsSameActive
        //     ? liActiveFontColor
        //     : this.options.liHoverTextIsThemeColor
        //         ? this.themeColor
        //         : this.options.liHoverFontColor && this.options.liHoverFontColor.color
        //             ? this.options.liHoverFontColor.color
        //             : this.options.liHoverFontColor,
        "--liHoverColor": this.options.liHoverIsSameActive ? liActiveFontColor : this.$parseColor(this.options.liHoverFontColor, {
          isThemeColor: this.options.liHoverTextIsThemeColor
        }),
        "--liHoverFontWeight": this.options.liHoverIsSameActive
            ? this.options.liActiveFontWeight
            : this.options.liHoverFontWeight,
        "--liHoverFontStyle": this.options.liHoverIsSameActive
            ? this.options.liActiveFontStyle
            : this.options.liHoverFontStyle,
        "--liHoverFontSize": (this.options.liHoverIsSameActive ? this.options.liActiveFontSize : this.options.liHoverFontSize) + "px",
        "--liHoverFontFamily": this.options.liHoverIsSameActive
            ? this.options.liActiveFontFamily
            : this.options.liHoverFontFamily,
        "--liHoverTextAlign": this.options.liHoverIsSameActive
            ? this.options.liActiveTextAlign
            : this.options.liHoverTextAlign,
        "--liHoverWritingMode": this.options.liHoverIsSameActive
            ? this.options.liActiveWritingMode
            : this.options.liHoverWritingMode,
        "--liHoverLetterSpacing": ( this.options.liHoverIsSameActive ? this.options.liActiveLetterSpacing : this.options.liHoverLetterSpacing) + "px",
        "--liHoverTextDecoration": this.options.liHoverIsSameActive
            ? this.options.liActiveTextDecoration
            : this.options.liHoverTextDecoration,
        "--liHoverBorderWidth": hoverBorderW,
        "--liHoverBorderBottomWidth": liHoverBorderBottomWidth,
        "--liHoverBorderStyle": this.options.liHoverIsSameActive ? this.options.liActiveBorderStyle : this.options.liHoverBorderStyle,
        // "--liHoverBorderColor": this.options.liHoverIsSameActive ? liActiveBorderColor : this.options.liHoverBorderIsThemeColor
        //     ? this.themeColor
        //     : this.options.liHoverBorderColor && this.options.liHoverBorderColor.color
        //         ? this.options.liHoverBorderColor.color
        //         : this.options.liHoverBorderColor,
        "--liHoverBorderColor": this.options.liHoverIsSameActive ? liActiveBorderColor : this.$parseColor(this.options.liHoverBorderColor, {
          isThemeColor: this.options.liHoverBorderIsThemeColor
        }),
        "--liHoverLineHeight": this.options.liHoverIsSameActive ? liActiveLineHeight : (actualLiHoverLineHeight + "px"),
        "--liActiveColor": liActiveFontColor,
        "--liActiveFontWeight": this.options.liActiveFontWeight,
        "--liActiveFontStyle": this.options.liActiveFontStyle,
        "--liActiveFontSize": this.options.liActiveFontSize + "px",
        "--liActiveFontFamily": this.options.liActiveFontFamily,
        "--liActiveTextAlign": this.options.liActiveTextAlign,
        "--liActiveWritingMode": this.options.liActiveWritingMode,
        "--liActiveLetterSpacing": this.options.liActiveLetterSpacing + "px",
        "--liActiveTextDecoration": this.options.liActiveTextDecoration,
        "--liActiveBorderWidth": activeBorderW,
        "--liActiveBorderBottomWidth": activeBorderBottomWidth,
        "--liActiveLineHeight": liActiveLineHeight,
        "--liActiveBorderStyle": this.options.liActiveBorderStyle,
        "--liActiveBorderColor": liActiveBorderColor,
        "--liMarginBottom": (this.options.liMarginBottom || 0) + "px",
        "--borderRadius1": `${this.options.topNavBorderTopLeftRadius1}px ${this.options.topNavBorderTopRightRadius1}px ${this.options.topNavBorderBottomRightRadius1}px ${this.options.topNavBorderBottomLeftRadius1}px`,
        ...bg
      }
    },
  },
  created() {},
  methods:{
    handleMenuClick(index,items){
      this.$emit("handleMenuClick",index,items)
    }
  }
}
</script>

<style scoped>
::v-deep .el-submenu__title svg * {
  stroke: var(--iconColor);
}
</style>
